// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"2d097e6d","160":"d5dd50c5","208":"87f193b5","293":"80c15801","453":"acca0757","516":"e7d79ac3","519":"e6ad261f","917":"d699c53f","946":"da108111"}[chunkId] + ".chunk.js";
};